<div class="row justify-content-center">
  <div class="col-md-4 py-3">
    <div class="brdr w-25 mb-3"></div>

    <h3 class="pt-2">
      Trending <br />
      Movies <br />
      To Watch Righ Now
    </h3>
    <p class="secondFontColor py-2">most watched movies by days</p>

    <div class="brdr w-100 mt-3"></div>
  </div>

  <div *ngFor="let movie of trendingMovies" class="col-md-2 py-3">
    <div
      [routerLink]="['/moviedetails', movie?.id]"
      class="movie position-relative"
    >
      <div class="position-relative posterr overflow-hidden">
        <img
          class="w-100 rounded"
          [src]="imgPrefix + movie?.poster_path"
          alt=""
        />
        <div
          class="
            layer
            position-absolute
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <h6 class="text-wight">more info..</h6>
        </div>
      </div>
      <h4 class="my-2 h5">{{ movie?.title }}</h4>

      <div class="vote position-absolute rounded-right">
        {{ movie?.vote_average }}
      </div>
    </div>
  </div>
</div>

<div class="row py-5">
  <div class="col-md-4 py-3">
    <div class="brdr w-25 mb-3"></div>

    <h3 class="pt-2">
      Trending <br />
      Tv <br />
      To Watch Righ Now
    </h3>
    <p class="secondFontColor py-2">most watched movies by days</p>

    <div class="brdr w-100 mt-3"></div>
  </div>

  <div *ngFor="let tv of trendingTv" class="col-md-2 py-3">
    <div
      [routerLink]="['/moviedetails', tv?.id]"
      class="movie position-relative"
    >
      <div class="position-relative posterr overflow-hidden">
        <img class="w-100" [src]="imgPrefix + tv?.poster_path" alt="" />
        <div
          class="
            layer
            position-absolute
            d-flex
            justify-content-center
            align-items-center
          "
        >
          <h6 class="text-wight">more info..</h6>
        </div>
      </div>
      <h4 class="my-2 h5">{{ tv?.name }}</h4>

      <div class="vote position-absolute rounded-right">
        {{ tv?.vote_average }}
      </div>
    </div>
  </div>
</div>
